<template>
  <div>

    <v-card>
      <v-card-title class="headline">Insights</v-card-title>

      <v-card-text>      
        <p>
          Key metrics are calculated weekly. Reports are always generated based on Monday - Sunday weekly intervals.
        </p>
      </v-card-text>

      <v-card-text v-if="insights">
        <h4>Key Metrics</h4>
        <p v-if="insights.current">
          Based on period running from 
          {{insights.current.from | localDate('ddd L', true) }}
          until
          {{insights.current.till | localDate('ddd L', true) }} (included).
        </p>
        <v-alert v-if="insights.current && insights.current.partial" type="info" text>
          Reporting is based on a partial week. 
          This might impact the results of this period compared to other periods.
        </v-alert>
        <p v-if="!insights.current">
          Please wait a few days to collect some data for the first metrics to start showing.
        </p>
      </v-card-text>
      <v-card-text v-if="insights && insights.today">
        <h4>Today</h4>
        <v-progress-circular :value="(insights.today.current / insights.today.goal) * 100" rotate="-90" size="200" color="primary" width="10">
          <template v-slot:default> {{ insights.today.current | int }} out of {{ insights.today.goal | int }} </template>
        </v-progress-circular>
        <p class="text-muted">
          Last updated on: {{ insights.today.last_update | localDate('ddd L LTS Z') }}
        </p>
      </v-card-text>
      <v-container class="mt-0" v-if="insights && insights.current">
        <v-row>
          <v-col cols="12" sm="4" md="6">
            <v-card class="white--text" color="primary darken-2">
              <v-card-text class="white--text">Daily Goal</v-card-text>
              <v-card-title v-if="insights.current.daily_goal" class="subtitle">{{ insights.current.daily_goal | int }} points</v-card-title>
              <v-card-title v-else class="subtitle">n/a</v-card-title>
              <!-- <p v-if="insights.current.points_till_next_tier" class="subtitle">Points needed to advance to next league: {{ insights.current.points_till_next_tier }}</p> -->
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="6">
            <v-card class="white--text" color="primary darken-2">
              <v-card-text class="white--text">Days remaining</v-card-text>
              <v-card-title v-if="insights.current.days_remaining" class="subtitle">{{ insights.current.days_remaining }} days</v-card-title>
              <v-card-title v-else class="subtitle">n/a</v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="6">
            <v-card class="white--text" color="secondary darken-2">
              <v-card-text class="white--text">League</v-card-text>
              <v-card-title v-if="insights.previous.tier" class="subtitle">{{ insights.tiers.find(x => x.value == insights.previous.tier).name }}</v-card-title>
              <v-card-title v-else class="subtitle">n/a</v-card-title>
              <!-- <p v-if="insights.current.points_till_next_tier" class="subtitle">Points needed to advance to next league: {{ insights.current.points_till_next_tier }}</p> -->
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="6">
            <v-card class="white--text" color="secondary darken-2">
              <v-card-text class="white--text">Streak</v-card-text>
              <v-card-title v-if="insights.previous.streak_length" class="subtitle">{{ insights.previous.streak_length }} weeks</v-card-title>
              <v-card-title v-else class="subtitle">n/a</v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-card-text v-if="insights && insights.current && insights.current.points_day">
        <v-header>Points by day</v-header>
        <RaceHistogramByDate :data="insights.current.points_day" label="Points by day" :defaultColor="$vuetify.theme.defaults.light.primary"  :accentColor="$helpers.getColorVariant($vuetify.theme.defaults.light.primary, 100)" />
      </v-card-text>

    </v-card>
      <v-card-text v-if="insights">
        <v-header>Week-by-week breakdown</v-header>
        <div v-for="(item, idx) in insights.snapshots" :key="idx" class="d-flex ">
          <div class="d-flex px-2" style="flex: 200px;">
            <strong>Week:&nbsp;</strong>
            <div>
              {{item.from | localDate('D', true) }}
              -
              {{item.till | localDate('D', true) }}
              <span v-if="item.partial">(partial)</span>
            </div>
          </div>
          <div class="d-flex px-2" style="flex: 50px;">
            <span v-if="item.tier">{{item.tier }}</span>
            <span v-if="item.tier_score" class="text-muted">({{item.tier_score | int }} pts)</span>
          </div>
          <div class="d-flex px-2" style="flex: 50px;">
            <span v-if="item.streak_length">{{item.streak_length }} wk(s)</span>
          </div>
        </div>
      </v-card-text>

    </v-card>
  </div>      
</template>

<script>
import { mapGetters } from "vuex";
import RaceHistogramByDate from '@/components/RaceHistogramByDate.vue'
import profileService from "@/services/profileService";
import { EventBus } from '@/plugins/eventbus.js';
import siteData from '@/data/site.json'

export default {
  name: "Insights",
  components: {
    RaceHistogramByDate,
  },
  props: {
  },
  data() {
    return {
      insights: null,
      siteData: siteData,

    };
  },
  async mounted() {
    await this.getProfile();
    
    EventBus.$on('login-state-change', async user => {
      await this.getProfile();
    });
  },
  methods: {

    async getProfile() {
      if (this.user) {
        this.insights = (await profileService.getInsights(this.$route.query.date)).data;
      }
    },

    // getStatsForRace(raceId) {
    //   return this.stats && this.stats.participants_by_race && this.stats.participants_by_race[raceId];
    // },

  },
  computed: {
    breadcrumbItems() {
      return !this.event ? [] : [
        { text: 'Profile', exact: true, to: { name: 'profile' } },
        { text: `Insights`, disabled: true },
      ];
    },

    ...mapGetters({
      user: "user"
    })
  },
};
</script>
<style lang="scss">
</style>

